<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-example === cce -->
      <div class="cce">
        <div class="cce-box custom-item">
          <!-- 内容 -->
          <!-- <img src="@assets/img/template/company-component-cove-9.jpg" width="100%" /> -->
          <div class="custom-m-item">
            <div class="cmi-title">{{Modal.title || '成功案例'}}</div>
            <div class="cmi-more">
              更多
              <Icon type="ios-arrow-forward" />
            </div>
            <div class="cmi-example"> 
              <gSwiperCommon :list="list" v-if="list.length"></gSwiperCommon> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gSwiperCommon from "@components/gSwiperCommon/gSwiperCommon.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 成功案例
  name: "custom-company-example",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "成功案例",
          type: 7,
          isOpen: true,
          title: "成功案例"
        };
      }
    }
  },
  data() {
    return {
      visible: false,
 
      list: [],
      pageSize: 18,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    Load(val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      Load: "customCompanyModule/getLoad",
      activeIndex: "customCompanyModule/getActiveIndex"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getExample: "companyModule/getExample"
    }),
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    async init() {
      let result = await this.getExample(this.option);
      let arr = [];
      if (result) {
        result.items.map(c => {
          // let
          if (c.photo) {
            c.photo = JSON.parse(c.photo);
            if (c.photo[0]) {
              arr.push(c.photo[0]);
            }
          }
          c.visible = false;
        });  
        this.list = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/case/add";
      window.open(link);
    }
  },
  components: {
    gSwiperCommon
  }
};
</script> 
<style scoped lang="scss">
.cce {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ccep {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
